<template>
    <div class="Contact">
        <div class="container">
            <h2>{{'Contact Us' | language}}</h2>

            <div class="row">
                <div class="col-xs-12 col-sm-6 col">
                    <h5>{{'Send an enquiry' | language}}</h5>

                    <el-alert
                        v-if="success === true"
                        title="Thanks, your enquiry has been sent successfully."
                        type="success"
                        show-icon>
                    </el-alert>
                    <el-alert
                        v-if="error === true"
                        title="There was an error sending your message, please try again later."
                        type="error"
                        show-icon>
                    </el-alert>

                    <el-form :label-position="labelPosition" ref="form" :model="ContactForm" label-width="120px" :rules="rules">
                        <el-form-item :label="'Name' | language" prop="name">
                            <el-input v-model="ContactForm.name" @keyup.enter.native="submit('form')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Email' | language" prop="email">
                            <el-input v-model="ContactForm.email" @keyup.enter.native="submit('form')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Phone' | language" prop="phone">
                            <el-input v-model="ContactForm.phone" @keyup.enter.native="submit('form')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Message' | language" prop="message">
                            <el-input type="textarea" v-model="ContactForm.message" rows="6" @keyup.enter.native="submit('form')">
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="Contact__Button" type="primary" @click="submit('form')" :loading="loading">{{'Submit' | language}}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <h5>{{'Find your nearest office' | language}}</h5>

                    <div class="Contact__Location">
                        <GmapMap
                            :center="position_nagoya"
                            :zoom="15"
                            map-type-id="roadmap"
                            v-bind:options="mapStyle"
                            style="width: 100%; height: 150px"
                            >
                            <GmapMarker
                                :position="position_nagoya"
                                :draggable="false"
                                :icon="icon"
                            />
                        </GmapMap>

                        <div class="info">
                            <a href="http://maps.google.com/?q=Ichigo Fushimi Bldg. 4F 1-18-24 Nishiki Nagoya-shi, Naka-ku 460-0003 Japan" target="_blank">
                                Ichigo Fushimi Bldg. 4F <br>
                                1-18-24 Nishiki <br>
                                Nagoya-shi, Naka-ku <br>
                                460-0003 Japan
                            </a>

                            <p><b>Tel:</b> <a href="tel:+810522298575">+81 (0)52-229-8575</a> <br>
                            <b>Fax:</b> <span>+81 (0)52-229-8590</span></p>
                        </div>
                    </div>
                    <div class="Contact__Location">
                        <GmapMap
                            :center="position_tokyo"
                            :zoom="15"
                            map-type-id="roadmap"
                            v-bind:options="mapStyle"
                            style="width: 100%; height: 150px"
                            >
                            <GmapMarker
                                :position="position_tokyo"
                                :draggable="false"
                                :icon="icon"
                            />
                        </GmapMap>
                        <div class="info">
                            <a href="http://maps.google.com/?q=7F Toranomon 40MT Bldg. 5-13-1, Toranomon, Minato-ku, Tokyo 〒105-0001 Japan" target="_blank">
                                7F Toranomon 40MT Bldg.<br>
                                5-13-1, Toranomon,<br>
                                Minato-ku, Tokyo<br>
                                〒105-0001 Japan
                            </a>

                            <p><b>Tel:</b> <a href="tel:+810368697276">+81 (0)3 4530 9760</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '../../../../config'

    export default {
        name: 'contact',

        mapStyle: config.MAP_STYLE,
        icon: {
            url: 'https://i.ibb.co/sVqyJS2/jhf-marker-price.png',
            size: { width: 80, height: 30, f: 'px', b: 'px' },
            scaledSize: { width: 80, height: 30, f: 'px', b: 'px' }
        },

        data: function () {
            return {
                labelPosition: 'top',
                ContactForm: {
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                },
                rules: {
                    name: [
                        { message: 'Name is required', required: true }
                    ],
                    email: [
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ],
                    message: [
                        { message: 'Message is required', required: true }
                    ],
                },
                error: false,
                loading: false,
                success: false,

                mapStyle: config.MAP_STYLE,
                icon: {
                    url: 'https://i.ibb.co/9sMJ7mM/jhf-marker-list.png',
                    size: {width: 30, height: 40, f: 'px', b: 'px'},
                    scaledSize: {width: 30, height: 40, f: 'px', b: 'px'}
                },
                position_nagoya: {
                    lat: 35.168505,
                    lng: 136.894060
                },
                position_tokyo: {
                    lat: 35.670589,
                    lng: 139.750384
                },
                position_kobe: {
                    lat: 34.678727,
                    lng: 135.175179
                }
            }
        },
        methods: {
            submit(formName) {
                event.preventDefault()
                 this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.success = false
                        this.error = false
                        const promise = this.$store.dispatch('general/sendEnquiry', this.ContactForm)
                        promise
                        .then(() => {
                            this.success = true
                        })
                        .catch(() => {
                            this.error = true
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    } else {
                        return false;
                    }
                });

            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Contact'
                }
            },
            meta: [
                { name: 'title', content: 'Contact Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .Contact {
        padding: 1em 0;

        .Contact__Location {
            margin-bottom: 2em;

            .vue-map-container {
                border: 1px solid rgba($alternate-color, .1);
                border-radius: 3px;
            }

            a {
                line-height: 1.4em;
                font-size: .9em;
                margin-top: .5em;
                display: inline-block;
                font-weight: 600;
                color: $alternate-color;
            }

            .info {
                display: flex;
                justify-content: space-between;

                p {
                    line-height: 1.4em;

                    a, span {
                        font-weight: 600;
                        display: inline-block;
                        font-size: .9em;
                    }

                    b {
                        width: 35px;
                        display: inline-block;
                        color: rgba($alternate-color, .5);
                    }
                }
            }
        }

        .col {
            padding-right: 3em;
        }

        h2 {
            text-align: center;
        }

        .el-form-item {
            &.is-error {
                margin-bottom: 1em!important;
            }
        }

        &__Button {
            margin-top: 2em;
        }

        @media (max-width: 767px) {
            .col {
                padding: 0 .5em 2em .5em;
            }
        }
    }
</style>